const STATUS = {
  'INTRO': 'intro', // show intro animation
  'INTRO_DEMO': 'intro-demo', // phase 2 or intro animation showing the demo
  'LOGO': 'logo', // show the logo
  'GAME_START': 'game-start', // slide in cards
  'GAME_PLAY': 'game-play', // render interactive cards
  'GAME_END': 'game-end', // fade the cards out
  'GAME_EXIT': 'game-exit', // move the side back out of the screen, show end message
  'CTA': 'cta', // show "well played" message and CTA
}

export default STATUS;



// WEBPACK FOOTER //
// ./src/components/rlgl/Game/constants.js